import CryptoJS from 'crypto-js';

const secretKey = 'TJS_CLAVE_ANUAL_20_24';

export const secureStorage = {
    setItem(key, value){
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
        localStorage.setItem(key,encryptedValue);
    },
    getItem(key){
        const encryptedValue = localStorage.getItem(key);
        if (encryptedValue){
            const bytes = CryptoJS.AES.decrypt(encryptedValue,secretKey);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return null;
    },
    removeItem(key){
        localStorage.removeItem(key);
    },
};